import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';

export interface OrgMember {
  user_id: string;
  email: string;
  full_name: string;
  role: string;
}

export const useOrgMembers = () => {
  const [members, setMembers] = useState<OrgMember[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    supabase
      .rpc('get_org_members')
      .then(({ data }) => {
        setMembers(data || []);
        setIsLoading(false);
      });
  }, []);

  return { members, isLoading };
};
